import React from 'react';
import moment from 'moment';
import useTranslation from '../../../hooks/translation/useTranslation';
import CustomerTextInput from '../../inputs/customerTextInput/CustomerTextInput';
import CustomerSelectInput from '../../inputs/customerSelectInput/CustomerSelectInput';
import CustomerCheckInput from '../../inputs/customerCheckInput/CustomerCheckInput';
import CustomerDateInput from '../../inputs/customerDateInput/CustomerDateInput';

function PassengersListItemForm({
  form,
  formListName,
  index,
  savedPassengers,
  numberOfPassengers,
  childPassengerValues,
  birthRequired,
}) {
  const { trans } = useTranslation();

  const handleSavedPassengerSelect = (e) => {
    const passengers = form.getFieldValue(formListName);
    const savedPassenger = savedPassengers?.find(({ id }) => id === e);
    passengers[index] = {
      ...passengers[index],
      ...savedPassenger,
      ...(savedPassenger?.birth_date && {
        birth_date: moment(savedPassenger?.birth_date),
      }),
      saved_passenger: e,
    };
    form.setFieldValue(formListName, passengers);
  };

  return (
    <div className="max-w-[760px] flex flex-col gap-4 lg:block">
      <div className="flex flex-col lg:flex-row gap-4 lg:items-end">
        <CustomerSelectInput
          className="basis-1/2 white-background"
          label={trans('chosen_passengers')}
          name={[index, 'saved_passenger']}
          options={savedPassengers?.map(({ label, id }) => ({
            label,
            value: id,
          }))}
          onChange={handleSavedPassengerSelect}
        />
        <div
          className={`h-full basis-1/2 mb-6 pl-4 ${
            numberOfPassengers > 1 && 'flex flex-col sm:flex-row sm:gap-4'
          }`}
        >
          <CustomerCheckInput
            className="h-[60px]"
            label={trans('save_in_chosen_passengers')}
            name={[index, 'save_passenger']}
          />
          {numberOfPassengers > 1 && (
            <CustomerCheckInput
              className="h-[60px]"
              label={trans('children_ticket')}
              name={[index, 'child_passenger']}
            />
          )}
        </div>
      </div>
      <div className="flex flex-col lg:flex-row gap-4">
        <CustomerTextInput
          className="flex-1"
          label={trans('first_name')}
          name={[index, 'first_name']}
          rules={[{ required: true, message: trans('input_necessary') }]}
        />
        <CustomerTextInput
          className="flex-1"
          label={trans('last_name')}
          name={[index, 'last_name']}
          rules={[{ required: true, message: trans('input_necessary') }]}
        />
      </div>
      <div className="flex flex-col lg:flex-row gap-4">
        <CustomerTextInput
          className="flex-1"
          label={trans('document_number')}
          name={[index, 'id_number']}
          rules={[{ required: true, message: trans('input_necessary') }]}
        />
        <CustomerDateInput
          name={[index, 'birth_date']}
          className="flex-1 flex justify-center"
          label={trans('birth_date')}
          locale="en_US"
          rules={
            childPassengerValues === true || birthRequired
              ? [{ required: true, message: trans('input_necessary') }]
              : []
          }
          maxDate={moment().subtract(1, 'day')}
        />
      </div>
    </div>
  );
}

export default PassengersListItemForm;
